import React from "react";
import { useFormContext, Controller } from "react-hook-form";
import './Form.css';

interface RadioProps {
  name: string;
  value: string | number | boolean;
  label?: string;
  isDisabled?: boolean;
  className?: string;
  required?: boolean;
  requiredMessage?: string;
  /** Optional side-effect callback fired with the new value after field.onChange. */
  onValueChange?: (value: string | number | boolean) => void;
}

const Radio: React.FC<RadioProps> = ({
  name,
  value,
  label,
  isDisabled = false,
  className = "",
  required = true,
  requiredMessage = 'This field is required',
  onValueChange
}) => {
  const {
    control,
    formState: { errors },
    trigger
  } = useFormContext();

  const error = errors[name];

  return (
    <Controller
      name={name}
      control={control}
      rules={{
        required: required ? requiredMessage : false
      }}
      render={({ field }) => {
        const isChecked = field.value !== undefined && String(field.value) === String(value);
        
        return (
            <label className={`radio-container ${className} ${isDisabled ? "radio-disabled" : ""}`}>
              <input
                type="radio"
                value={String(value)}
                disabled={isDisabled}
                checked={isChecked}
                onChange={() => {
                  field.onChange(value);
                  trigger(name);
                  onValueChange?.(value);
                }}
                onBlur={field.onBlur}
                ref={field.ref}
                className={`radio-input ${error ? 'is-invalid' : ''}`}
              />
              <span className={`radio-custom ${isChecked ? "radio-checked" : ""}`} style={{ left: '4px' }}>
                {isChecked && <span className="radio-dot"></span>}
              </span>
              {label && <span className="radio-label">{label}</span>}
            </label>
        );
      }}
    />
  );
};

export default Radio;